module.exports = __webpack_public_path__ + "static/media/whatsapp.e8667091.svg";